import { render, staticRenderFns } from "./luxury-terms-dialog.vue?vue&type=template&id=2af0ad21&scoped=true&"
import script from "./luxury-terms-dialog.vue?vue&type=script&lang=js&"
export * from "./luxury-terms-dialog.vue?vue&type=script&lang=js&"
import style0 from "./luxury-terms-dialog.vue?vue&type=style&index=0&id=2af0ad21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af0ad21",
  null
  
)

export default component.exports